
import Component from "vue-class-component";
import Vue from "vue";
import { SystemModule } from "@/store/modules";
import { getModule } from "vuex-module-decorators";
import Select from "@/components/form/Select.vue";
import { formatDateWithTime } from "@/utils";
import notifications from "../lib/notifications";
import {
  GetCommodityUnloadTimesEffectiveRequest,
  CommodityUnloadTimesEffectiveResource,
  EditCommodityUnloadTimeOverideModel
} from "../models/api/system/commodityUnloadTimeOverride";

const systemModule = getModule(SystemModule);

@Component({
  components: {
    Select
  }
})
export default class ImportTrucks extends Vue {
  commodities: any = null;
  commodityCode: string = null;
  facilityCode: string = null;
  overriddenOnly: boolean = false;
  loading: boolean = false;
  records: CommodityUnloadTimesEffectiveResource[] = null;
  editId: number = null;
  editModel: EditCommodityUnloadTimeOverideModel = null;

  timeInformation: any = {
    hours: "00",
    minutes: "00",
    seconds: "00",
    modalIsVisible: false
  };

  async created() {
    await this.loadCommodities();
    if (systemModule.facilities && systemModule.facilities.length == 1)
      this.facilityCode = systemModule.facilities[0].facilityCode;
  }

  async loadCommodities() {
    try {
      const results = await systemModule.searchCommoditiesByCode({ code: null, billTo: null });
      this.$data.commodities = results.map(x => ({ label: x.agentId, value: x.code }));
    } catch (ex) {
      console.error("Failed to load commodities", ex);
    }
  }

  async loadData() {
    this.loading = true;
    try {
      this.records = await systemModule.getCommodityUnloadTimesEffective({
        commodityCode: this.commodityCode,
        facilityCode: this.facilityCode,
        overriddenOnly: this.overriddenOnly
      });
    } catch (ex) {
      notifications.error("Search Failed", "Failed to load records", ex);
    }
    this.loading = false;
  }

  format(dateToFormat) {
    return formatDateWithTime(dateToFormat);
  }

  goBack() {
    this.$router.back();
  }

  async filter() {
    await this.loadData();
  }

  editRecord(record: CommodityUnloadTimesEffectiveResource = null) {
    const model = new EditCommodityUnloadTimeOverideModel();
    if (record) {
      const data = record.timePerUnit.split(":");

      model.commodityCode = record.commodityCode;
      model.facilityCode = record.facilityCode ? record.facilityCode : this.facilityCode;
      this.timeInformation.hours = data[0];
      this.timeInformation.minutes = data[1];
      this.timeInformation.seconds = data[2];
    } else {
      model.facilityCode = this.facilityCode;
      this.timeInformation.hours = "00";
      this.timeInformation.minutes = "00";
      this.timeInformation.seconds = "00";
    }

    this.editModel = model;
  }

  closeEditModal() {
    this.editModel.visible = false;
    this.editModel = null;
  }

  async saveRecord() {
    try {
      this.editModel.saving = true;
      this.editModel.timePerUnit =
        this.timeInformation.hours +
        ":" +
        this.timeInformation.minutes +
        ":" +
        this.timeInformation.seconds;
      await systemModule.createCommodityUnloadTimeOverride(this.editModel.toCreateRequest());
      await this.loadData();
      this.editModel.visible = false;
      this.editModel = null;
      notifications.success("Save Success", "Record successfully saved");
    } catch (ex) {
      this.editModel.saving = false;
      notifications.error("Save Failed", "Failed to save record", ex);
    }
  }

  async deleteRecord(record: CommodityUnloadTimesEffectiveResource) {
    const confirmed = await this.$bvModal.msgBoxConfirm(
      "Are you sure you want to remove this override? This action cannot be undone."
    );
    if (confirmed) {
      try {
        await systemModule.deleteCommodityUnloadTimeOverride(record.id);
        await this.loadData();
        notifications.success(
          "Removed commodity unload time override",
          "Record successfully deleted."
        );
      } catch (ex) {
        notifications.error(
          "Removed commodity unload time override",
          "Failed to delete record",
          ex
        );
      }
    }
  }

  get canFilter() {
    return this.facilityCode != null;
  }

  get showFacilitySelect() {
    return systemModule.facilities && systemModule.facilities.length != 1;
  }
}
